// extracted by mini-css-extract-plugin
export default {"file-name":"wSSalO3M5gD3xdAwGAh1","deleted-file-icon":"a2lFiR0J5_57OdCYTgYd","file-icon":"YPYeEz172GDo8GePXVCM"};